import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import * as Core from 'app/core/models/essette-api';
import { I18N } from 'aurelia-i18n';

export enum AuthMethodType {
    Local = 'Essette',
    ActiveDirectory = 'Active Directory',
    SignOnProvider = 'Sign On Provider'
}

@autoinject
export class AccountTypeBadge {
    @bindable.object()
    protected user: Core.User | null = null;
    protected accountTypeAbbr: string | null = null;
    protected accountTypeTooltip: string | null = null;

    constructor(private readonly i18n: I18N) { }

    protected bind(): void {
        const authMethodType = this.user?.login?.authenticationMethod?.type;
        const authMethodDesc = this.user?.login?.authenticationMethod?.description;
        if(!!authMethodType) {
            switch(authMethodType) {
                case AuthMethodType.Local:
                    this.accountTypeAbbr = this.i18n.tr('core:account.type.local.$short');
                    this.accountTypeTooltip = this.i18n.tr('core:account.type.local.$');
                    break;
                case AuthMethodType.ActiveDirectory:
                    this.accountTypeAbbr = this.i18n.tr('core:account.type.activeDirectory.$short');
                    this.accountTypeTooltip = this.i18n.tr('core:account.type.activeDirectory.description', { what: authMethodDesc });
                    break;
                case AuthMethodType.SignOnProvider:
                    this.accountTypeAbbr = this.i18n.tr('core:account.type.oauth.$short');
                    this.accountTypeTooltip = this.i18n.tr('core:account.type.oauth.description', { what: authMethodDesc });
                    break;
            }
        }
    }
}
